"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Selector = void 0;
var tslib_1 = require("tslib");
var react_virtual_1 = require("@tanstack/react-virtual");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var popper_1 = require("../../popper");
var _1 = require(".");
function Selector(_a) {
    var getComboboxProps = _a.getComboboxProps, getDisabledProps = _a.getDisabledProps, getIsSelectedItem = _a.getIsSelectedItem, getItemKey = _a.getItemKey, getItemProps = _a.getItemProps, getMenuProps = _a.getMenuProps, highlightedIndex = _a.highlightedIndex, isLoading = _a.isLoading, isOpen = _a.isOpen, items = _a.items, menuFooter = _a.menuFooter, header = _a.header, renderInput = _a.renderInput, renderItem = _a.renderItem, renderItemHover = _a.renderItemHover, renderNoResults = _a.renderNoResults;
    var menuRef = (0, react_1.useRef)(null);
    var menuOverflowRef = (0, react_1.useRef)(null);
    var rowVirtualizer = (0, react_virtual_1.useVirtualizer)({
        count: items.length,
        getScrollElement: function () { return menuOverflowRef.current; },
        estimateSize: function () { return 125; },
        getItemKey: function (index) { return getItemKey(items[index]); },
    });
    return (react_1.default.createElement("div", (0, tslib_1.__assign)({}, getComboboxProps({
        style: {
            position: 'relative',
        },
    }, { suppressRefError: true })),
        react_1.default.createElement(popper_1.Popper, { style: {
                width: '100%',
            }, isOpen: isOpen, placement: "bottom", trigger: function (_a) {
                var triggerRef = _a.triggerRef;
                return renderInput({ triggerRef: triggerRef });
            } },
            react_1.default.createElement(_1.Menu, (0, tslib_1.__assign)({ header: header, isOpen: isOpen, isLoading: isLoading, overflowRef: menuOverflowRef }, getMenuProps({
                ref: menuRef,
            }, { suppressRefError: true }), { footer: menuFooter }), items.length === 0 ? (renderNoResults()) : (react_1.default.createElement("div", { style: {
                    height: rowVirtualizer.getTotalSize(),
                    position: 'relative',
                    width: '100%',
                } }, rowVirtualizer.getVirtualItems().map(function (virtualItem) {
                var item = items[virtualItem.index];
                var index = virtualItem.index;
                return (react_1.default.createElement("div", { key: virtualItem.key, ref: virtualItem.measureElement, style: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        transform: "translateY(".concat(virtualItem.start, "px)"),
                    } },
                    react_1.default.createElement(_1.SelectableItem, { key: getItemKey(item), getItemProps: getItemProps, item: item, isHovering: index === highlightedIndex, isSelected: getIsSelectedItem(item), index: index, renderItem: renderItem, renderItemHover: renderItemHover, getDisabledProps: getDisabledProps, hasScrollbarOffset: getElementHasScrollbar(menuRef.current).vertical })));
            })))))));
}
exports.Selector = Selector;
function getElementHasScrollbar(element) {
    if (!element) {
        return {
            horizontal: false,
            vertical: false,
        };
    }
    var hasHorizontalScrollbar = element.scrollWidth > element.clientWidth;
    var hasVerticalScrollbar = element.scrollHeight > element.clientHeight;
    return {
        horizontal: hasHorizontalScrollbar,
        vertical: hasVerticalScrollbar,
    };
}
//# sourceMappingURL=selector.js.map